module.exports = __webpack_public_path__ + "img/circle-sort-up.7f961914.svg";